// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".min-title[data-v-6de784c9]{margin:30px auto;text-align:center;height:24px;line-height:24px;width:100%}.min-title img[data-v-6de784c9]{margin:0 4px -2px}.min-title span[data-v-6de784c9]{font-size:23px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
